import { Box } from '@/src/packages/components';
import { CaretRight } from '@carbon/icons-react';
import { LucideIcon } from 'lucide-react';
import { ReactNode, Ref, forwardRef } from 'react';

export type IProductDetailProps = {
  children: ReactNode;
  icon: LucideIcon;
  onClick?(): void;
};

export const ProductDetailTrigger = forwardRef(
  (props: IProductDetailProps, ref: Ref<HTMLDivElement>) => {
    const { children, onClick } = props;

    return (
      <Box
        ref={ref}
        onClick={onClick}
        display="flex"
        alignItems="center"
        paddingY={4}
        className="cursor-pointer"
      >
        <Box className="flex-1">{children}</Box>
        <CaretRight className="ml-auto" />
      </Box>
    );
  }
);

ProductDetailTrigger.displayName = 'ProductDetailTrigger';
